"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionType = exports.DisplayMode = exports.DisplayFeedback = void 0;
let DisplayFeedback = exports.DisplayFeedback = /*#__PURE__*/function (DisplayFeedback) {
  DisplayFeedback[DisplayFeedback["Hidden"] = 0] = "Hidden";
  DisplayFeedback[DisplayFeedback["Delete"] = 1] = "Delete";
  DisplayFeedback[DisplayFeedback["Verify"] = 2] = "Verify";
  DisplayFeedback[DisplayFeedback["Add"] = 3] = "Add";
  DisplayFeedback[DisplayFeedback["Update"] = 4] = "Update";
  return DisplayFeedback;
}({});
let DisplayMode = exports.DisplayMode = /*#__PURE__*/function (DisplayMode) {
  DisplayMode[DisplayMode["Hidden"] = 0] = "Hidden";
  DisplayMode[DisplayMode["Read"] = 1] = "Read";
  DisplayMode[DisplayMode["Create"] = 2] = "Create";
  DisplayMode[DisplayMode["Update"] = 3] = "Update";
  DisplayMode[DisplayMode["Verify"] = 4] = "Verify";
  return DisplayMode;
}({});
let SectionType = exports.SectionType = /*#__PURE__*/function (SectionType) {
  SectionType["Profile"] = "profile";
  SectionType["Checkout"] = "checkout";
  return SectionType;
}({});
